import React, { useEffect } from 'react';
import {connect} from 'react-redux'
import clsx from 'clsx';

import withErrorHandler from '../../../hocs/withErrorHandler'
import axios from '../../../httpClients/axios-datamerch'
import * as actions from '../../../store/actions'

import NotesTable from '../NotesTable';
import { CircularProgress, Card, CardHeader, Divider } from '@mui/material';
import useClasses from '../../../helpers/useClasses';
import moment from 'moment';

const styles = theme => ({
  root: {
    padding: 0,
    margin: '25px'
  },
  content: {
    marginTop: theme.spacing(2)
  },
  table: {

  },
  th: {
    padding: '10px',
    textAlign: 'left'
  },
  td: {
    padding: '10px'
  }
});

const NoteListPDF = props => {
  const classes = useClasses(styles);

  const { 
    onFetchNotes,
    onNoteRestore,
    onNoteArchive,
    onNoteAdd,
    onNoteSave,
    onNoteCancel,
    onNoteDisputeCancel,
    onNoteDisputeSave,
    token,
    merchantId,
    className,
    loading,
    notes,
    accounts,
    loading_accounts,
    highlight,
    is_dm_admin,
    ...rest
  } = props
  
  useEffect(() => {
    onFetchNotes(token, merchantId);
  }, [onFetchNotes, token, merchantId])

  const handleArchiveClick = (event, noteId) => {
    event.preventDefault();

    onNoteArchive(token, noteId)
  }

  const handleSubmitNoteClick = (event, note) => {
    event.preventDefault();

    let noteData = {
      note: {
        merchant_id: merchantId,
        category: note.category,
        proxied_creator: note.proxied_creator,
        note: note.note,
        submission_source: note.submission_source,
        broker_name: note.broker_name
      }
    }

    if (note.id){
      noteData = {
        note: {
          id: note.id,
          merchant_id: merchantId,
          category: note.category,
          proxied_creator: '',
          note: note.note,
          submission_source: note.submission_source,
          broker_name: note.broker_name
        }
      }
    }

    if (note.id){
      onNoteSave(noteData, note.id)
    } else {
      onNoteAdd(noteData)
    }
  };

  const handleCancelNoteClick = (event) => {
    event.preventDefault();
    onNoteCancel()
  };


  const handleSubmitNoteDisputeClick = (event, note) => {
    event.preventDefault();
    const form = event.currentTarget.form

    let noteData = {
      note: {
        reason: ''
      }
    }

    if (note.id){
      noteData = {
        note: {
          id: note.id,
          reason: note.reason
        }
      }
    }

    if (note.id && form.reportValidity()){
      onNoteDisputeSave(noteData, note.id)
    } else {
      return false;
    }
  };

  const handleCancelNoteDisputeClick = (event) => {
    event.preventDefault();
    onNoteDisputeCancel()
  };

  let active_notes = <CircularProgress />
  if(!loading){
    active_notes = (
      <div className={classes.root}>
        <table className={classes.table}>
          <thead>
            <tr>
              <th className={classes.th}>
                Category
              </th>
              <th className={classes.th}>
                Date Added
              </th>
              <th className={classes.th}>
                Note
              </th>
              <th className={classes.th}>
                Added By
              </th>
            </tr>
          </thead>
          <tbody>
            {notes.map(note => (
              <tr>
                <td className={classes.td}>
                  {note.category} 
                </td>
                <td className={classes.td}>
                  {moment(note.created_at).format('MM/DD/YYYY')} 
                </td>
                <td width="50%" className={classes.td}>
                  {note.note} 
                </td>
                <td className={classes.td}>
                  {note.added_by}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }

  return (
    <React.Fragment>
      {active_notes}
    </React.Fragment>
  );
};

const mapStateToProps = state => {
  return {
    notes: state.note.notes,
    loading: state.note.loading,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onFetchNotes: (token, merchantId) => dispatch(actions.fetchNotes(token, merchantId)),
    onNoteArchive: (token, noteId) => dispatch(actions.archiveNote(token, noteId)),
    onNoteAdd: (noteData) => dispatch(actions.addNote(noteData)),
    onNoteSave: (noteData, id) => dispatch(actions.updateNote(noteData, id)),
    onNoteCancel: () => dispatch(actions.closeNoteModal()),
    onNoteDisputeCancel: () => dispatch(actions.closeNoteDisputeModal()),
    onNoteDisputeSave: (noteData, id) => dispatch(actions.disputeNote(noteData, id))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(NoteListPDF, axios))